import { Fragment, useEffect, useState } from 'react';
import {
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
} from '@mui/material';
import MuiRadioGroup from './components/MuiRadioGroup';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import { StyledTableCellTwo } from 'routes/Main/style';
import { Box, Stack, useTheme } from '@mui/system';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
  setSum2: (sum2: number) => void;
}

const Contents2 = (props: Props) => {
  const { disabled, getValues, setValue, setSum2 } = props;

  const [num01, setNum01] = useState(
    getValues('kdsq_c_06') ? getValues('kdsq_c_06') : 0
  );
  const [num02, setNum02] = useState(
    getValues('kdsq_c_07') ? getValues('kdsq_c_07') : 0
  );
  const [num03, setNum03] = useState(
    getValues('kdsq_c_08') ? getValues('kdsq_c_08') : 0
  );
  const [num04, setNum04] = useState(
    getValues('kdsq_c_09') ? getValues('kdsq_c_09') : 0
  );
  const [num05, setNum05] = useState(
    getValues('kdsq_c_10') ? getValues('kdsq_c_10') : 0
  );

  useEffect(() => setSum2(num01 + num02 + num03 + num04 + num05));

  return (
    <Fragment>
      <SectionTitle title="Other (KDSQ-O)" />

      <Grid item xs={12}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  whiteSpace: 'nowrap',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  fontSize: '12px',
                  paddingLeft: '30px',
                }}
              >
                <Stack direction="row" gap={16.5}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    아니다(0점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    가끔 그렇다(1점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    자주 그렇다(2점)
                  </Typography>
                </Stack>
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  6. 물건이나, 사람의 이름을 대기가 힘들어 머뭇거린다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_06')}
                  onChange={v => {
                    setValue('kdsq_c_06', Number(v));
                    setNum01(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  7. 대화 중 내용이 이해되지 않아 반복해서 물어본다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_07')}
                  onChange={v => {
                    setValue('kdsq_c_07', Number(v));
                    setNum02(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  8. 길을 잃거나 헤맨 적이 있다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_08')}
                  onChange={v => {
                    setValue('kdsq_c_08', Number(v));
                    setNum03(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  9. 예전에 비해서 계산 능력이 떨어졌다.(예: 물건값이나 거스름돈
                  계산을 못한다.)
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_09')}
                  onChange={v => {
                    setValue('kdsq_c_09', Number(v));
                    setNum04(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  10. 예전에 비해 성격이 변했다.
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_c_10')}
                  onChange={v => {
                    setValue('kdsq_c_10', Number(v));
                    setNum05(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Fragment>
  );
};

export default Contents2;
